/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Api_DisabledInputs */

const fr_api_drive_api_disabled = /** @type {(inputs: Api_Drive_Api_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une API Google nécessaire est désactivée. Demandez à un administrateur de vérifier les API Drive et Sheets du projet Google.`)
};

const en_api_drive_api_disabled = /** @type {(inputs: Api_Drive_Api_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A required Google API is disabled. Ask an administrator to check the Google project’s Drive and Sheets APIs.`)
};

/**
* | output |
* | --- |
* | "A required Google API is disabled. Ask an administrator to check the Google project’s Drive and Sheets APIs." |
*
* @param {Api_Drive_Api_DisabledInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_api_disabled = /** @type {((inputs?: Api_Drive_Api_DisabledInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Api_DisabledInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_api_disabled(inputs)
	return fr_api_drive_api_disabled(inputs)
});